import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import Logo from "../components/Logo";

const INK = "#14101F";
const CREAM = "#F5F2EC";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ fontFamily: "Inter, sans-serif", color: INK, minHeight: "100vh", background: CREAM, display: "grid", placeItems: "center", padding: 24 }}>
      <div className="sc-card-lg" style={{ width: "100%", maxWidth: 420, padding: 32 }}>
        <Logo height={64} />
        <h1 style={{ fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: 26, margin: "16px 0 6px", textTransform: "uppercase" }}>Reset password</h1>
        {sent ? (
          <>
            <p data-testid="forgot-sent" style={{ color: "#6a6478", fontSize: 14 }}>
              If an account exists for <strong>{email}</strong>, we've emailed a reset link. It expires in 1 hour.
            </p>
            <Link to="/login" className="sc-btn sc-btn-violet" style={{ marginTop: 18, padding: "10px 22px", fontSize: 14 }}>← Back to login</Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <p style={{ color: "#6a6478", fontSize: 14, margin: "0 0 16px" }}>Enter your account email and we'll send a reset link.</p>
            <input data-testid="forgot-email" className="sc-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.in" />
            <button data-testid="forgot-submit" type="submit" disabled={busy} className="sc-btn sc-btn-violet" style={{ width: "100%", marginTop: 16, padding: 13, fontSize: 15 }}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <Link to="/login" style={{ display: "block", textAlign: "center", marginTop: 14, fontFamily: "JetBrains Mono, monospace", fontSize: 12, color: "#6a6478", textDecoration: "none" }}>← Back to login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
